import Logo2020 from '../../src/legacy/Logo2020.tsx';
export default Logo2020;
